// src/main.js - ClassMom Vue.js Application Entry Point
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axios from 'axios'

// Import CSS
import './assets/main.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-toastification/dist/index.css'

// Import Toast
import Toast from 'vue-toastification'

// HTTP interceptor setup
import './services/http-interceptor'

loadFonts()

// Axios default configuration
axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/'

// Axios interceptor setup for authentication
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

import { initAuth } from '@/utils/auth'

// Create the Vue app instance
const app = createApp(App)

// Toast configuration for Vue 3
const toastOptions = {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true
}

// Install all plugins
app.use(router)
app.use(store)
app.use(vuetify)
app.use(Toast, toastOptions)

// Global error handler
app.config.errorHandler = (error, instance, info) => {
  console.error('Vue Error:', error, info)
  
  // You can add error tracking here
  if (instance && instance.$toast) {
    instance.$toast.error('An unexpected error occurred')
  }
}

// Global properties
app.config.globalProperties.$schoolName = process.env.VUE_APP_SCHOOL_NAME || 'ClassMom School'
app.config.globalProperties.$whatsappNumber = process.env.VUE_APP_WHATSAPP_NUMBER || '+27123456789'

console.log('MAIN.JS LOADING - ABOUT TO MOUNT APP')
console.log('Router loaded:', !!router)
console.log('School Name:', app.config.globalProperties.$schoolName)

console.log('Initializing authentication system...')
initAuth()

// Mount the app
app.mount('#app')